/* eslint-disable eqeqeq */
<template>
  <v-app id="cheerfulgive-checkOut">
    <v-main>
      <v-form ref="form">
       <v-container fluid class="mb-8">
        <!-- 浮動按鈕, 按此按鈕會到最下方結帳處 -->
         <v-btn
          class="text-h6 ma-2 orange2--text"
          color="orange3"
          depressed
          fab
          fixed
          bottom
          right
          :ripple="false"
          @click="$vuetify.goTo('#checkoutMethod', null)"
        >
          {{$t('checkout')}}
          <icon-chevronDown class="cheerfulgive-icon arrow-position" />
        </v-btn>

        <!-- 上方左右側按鈕 -->
        <div class="d-flex justify-space-between">
          <v-btn color="primary" elevation="2" outlined x-large class="text-h6" :ripple="false" @click="back">
            <icon-reply class="cheerfulgive-icon" />
            {{ $t('back') }}
          </v-btn>
          <v-btn color="blue" elevation="2" outlined x-large class="text-h6" :ripple="false" id="record-button" @click="toRecord">
            <icon-clipboardList class="cheerfulgive-icon" />
            {{ $t('receivePaymentInToday') }}
          </v-btn>
        </div>

        <!-- logo <images-logo2/>-->
        <v-row justify="center mt-6">
          <!-- 公司logo圖片依公司代入, 若不是則為空照片圖案 -->
            <v-img v-if="company.logoUrl"
              contain
              :max-height="207"
              :max-width="206"
              :src="company.logoUrl"
            ></v-img>
            <images-logo2 v-else/>
        </v-row>

        <!-- 商店收據開立方式 -->
          <v-row justify="center" id="store">
            <v-col cols="10" md="6">
              <!-- :item選擇商店, storeChange商店轉換-->
              <div id="store">
                <v-select
                  color="pimary"
                  v-model="form.store"
                  item-text="name"
                  :return-object="true"
                  :label="$t('pleaseSelectStore')"
                  :items="stores"
                  @change="storeChange"
                  attach
                  outlined>
                  <template v-slot:append>
                    <v-icon color="primary">$dropdown</v-icon>
                  </template>
                  <!-- 下拉選單商店名稱的格式 -->
                  <template v-slot:item="{item}">
                    {{item.name}} {{getStoreDescription(item)}}
                  </template>
                  <!-- 選到的商店名稱的格式, 才會顯示有後括弧的資料,比如:(免開) -->
                  <template v-slot:selection="{item}">
                    {{item.name}} {{getStoreDescription(item)}}
                  </template>
                </v-select>
              </div>
            </v-col>
          </v-row>

           <!-- 基本資料 -->
           <div class="mt-12">
              <v-row justify="center">
                <span
                  class="
                    text-subtitle text-center text-h4
                    primary--text
                    text--lighten-1
                    title
                  "
                  >{{ $t('basicInformation') }}</span
                >
              </v-row>
            <v-row justify="center">
               <v-col cols="10" md="6">
                 <div class="text-h6 d-flex align-center mb-2">
                   {{ $t('cellphoneNumber') }}
                 </div>
                 <!-- 基本資料 -->
                  <!-- keydown 按下鍵盤 -->
                  <v-text-field
                      id="cellphoneNumber"
                      v-model="form.payerCellphone"
                      outlined
                      required
                      :rules="payerCellphoneRules"
                      :placeholder="$t('pleaseInputCellphoneNumber')"
                      @keydown="cellphoneNumberChange"
                    >
                  </v-text-field>
                  <div class="text-h6 d-flex align-center mb-2">
                   {{ $t('lastName') }}
                 </div>
                  <v-text-field
                      id="lastName"
                      v-model="form.payerLastName"
                      :rules="payerLastNameRules"
                      outlined
                      required
                      :placeholder="$t('pleaseInputLastName')"
                    >
                  </v-text-field>
                   <div class="text-h6 d-flex align-center mb-2">
                   {{ $t('firstName') }}
                 </div>
                  <v-text-field
                      id="firstName"
                      v-model="form.payerFirstName"
                      :rules="payerFirstNameRules"
                      outlined
                      required
                      :placeholder="$t('pleaseInputFirstName')"
                    >
                  </v-text-field>
                <div class="text-h6 d-flex align-center mb-2">
                   {{ $t('email') }}
                 </div>
                  <v-text-field
                      id="email"
                      v-model="form.payerEmail"
                      outlined
                      :rules="payerEmailRules"
                      :required="isPayerEmailRequired"
                      :placeholder="$t('pleaseInputEmail')"
                    >
                  </v-text-field>
                </v-col>
            </v-row>
           </div>

          <!-- 項目 -->
           <div class="my-12">
            <v-row justify="center">
              <span
                class="
                  text-subtitle text-center text-h4
                  primary--text
                  text--lighten-1
                  title
                "
                >{{ $t('item') }}</span
              >
            </v-row>

          <!-- 產品列表 -->
            <v-row>
              <!-- 使用v-for所以需要設定唯一值key -->
              <v-col
                v-for="product in products"
                :key="product.id"
                cols="4"
              >
               <!-- v-bind綁定商店的產品與產品數量  -->
                <v-card
                  height= "430"
                  width= "100%"
                  class="my-3 product-card"
                  :ripple="false"
                  v-bind:class="{ 'product-selected ': product.quantity > 0 }"
                  @click="productClick(product)"
                  >
                  <template slot="progress">
                      <v-progress-linear
                        color="deep-purple"
                        height="10"
                        indeterminate
                      ></v-progress-linear>
                    </template>
                  <!-- 產品圖片依商店代入, 若不是則為空照片圖案 -->
                    <v-img v-if="product.picDefault"
                      contain
                      :height="260"
                      :src="product.picDefault"
                    ></v-img>
                    <v-img v-else
                      :height="260"
                      src="../assets/images/blank-photo.png"
                    ></v-img>
                     <v-card-title>{{product.name}}</v-card-title>
                     <!-- 數量型 -->
                     <v-card-text v-if="product.isStock">
                       <v-row align="center" class="mx-0">
                          <span v-if="product.isFixedPrice">{{product.price}}</span>
                          <span v-if="product.unit">/{{product.unit}}</span>
                       </v-row>
                        <v-row justify="end" class="mx-0">
                          <span v-if="product.quantity > 0">{{ $t('subtotal') }} {{ format(product.price* product.quantity)}}</span>
                          <span v-else>&nbsp;</span>
                        </v-row>

                        <v-row
                          class="justify-space-between"
                        >
                      <!-- vue-number-input為＋－數量欄位 -->
                        <v-col cols="7">
                           <vue-number-input v-model="product.quantity" :min="0" :max="product.maxQuantity" inline center controls></vue-number-input>
                        </v-col>
                        <v-col cols="4">
                          <v-btn
                            class="btn-clear"
                            color="white"
                            depressed
                            :ripple="false"
                            v-on:click.stop="clear(product)"
                          >
                          {{ $t('clear') }}
                          </v-btn>
                        </v-col>
                       </v-row>
                     </v-card-text>
                     <!-- 固定金額 -->
                     <v-card-text v-else-if="product.isFixedPrice">
                       <v-row
                          align="center"
                          class="mx-0"
                        >
                        {{ format (product.price) }}
                       </v-row>
                        <v-row
                          justify="end"
                          class="mx-0"
                        >

                       </v-row>
                       <v-row
                          justify="end"
                          class="mx-14"
                        >
                        <v-col cols="2">
                          <v-btn
                           class="mr-8 btn-clear"
                            color="white"
                            depressed
                            :ripple="false"
                            v-on:click.stop="clear(product)"
                          >
                          {{ $t('clear') }}
                          </v-btn>
                        </v-col>
                       </v-row>
                     </v-card-text>
                     <!-- 非固定金額 -->
                      <v-card-text v-else>
                       <v-row
                          align="center"
                          class="mx-2 my-1"
                        >

                      </v-row>

                       <v-row
                          justify="end"
                        >
                        <!-- 填入金額最大值與最小值設定 -->
                        <v-col cols="7">
                          <v-text-field
                            type="number"
                            class="input-amount white--background"
                            v-model="product.price"
                            :min="product.minPrice >=0 ? product.minPrice : 0"
                            :max="product.maxPrice >=0 ? product.maxPrice : 9999999"
                            outlined
                            @input="productPriceChange(product)">
                         </v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-btn
                           class="btn-clear"
                            color="white"
                            depressed
                            :ripple="false"
                            v-on:click.stop="product.price = 0"
                          >
                          {{ $t('clear') }}
                          </v-btn>
                        </v-col>
                       </v-row>
                     </v-card-text>
                  </v-card>
              </v-col>
            </v-row>
            </div>
            <v-divider></v-divider>
            <div class="my-12 text-right">
              <span class="text-h5">{{ $t('amount') }} {{totalStr}}</span>
            </div>

          <!-- 結帳區 -->
          <!--  附捐款收據(可扣抵 & 不可扣抵) v-if依據商店可用模式顯示-->
            <div class="my-12" >
            <v-row justify="center" v-if="form.store.isReceiptDuctable">
              <span
                class="
                  text-subtitle text-center text-h4
                  primary--text
                  text--lighten-1
                  title
                "
                >{{ $t('donateReceiptDeductible') }}</span
              >
            </v-row>
            <v-row justify="center" v-if="form.store.isReceiptDisductable">
              <span
                class="
                  text-subtitle text-center text-h4
                  primary--text
                  text--lighten-1
                  title
                "
                >{{ $t('donateReceiptNonDeductible') }}</span
              >
            </v-row>
            <!--  商店為附捐款收據(可扣抵 & 不可扣抵) v-if依據商店可用模式顯示-->
            <div class="mt-12" v-if="form.store.isReceiptDuctable||form.store.isReceiptDisductable">
              <v-row justify="center">
                <v-col cols="6">
                <span>{{ $t('receiptTypeName') }}</span>
                <v-radio-group
                    id="receiptTypeName"
                    v-model="form.receiptTypeCode"
                    @change="receiptTypeCodeChange"
                    row
                  >
                    <v-radio
                      id="byTime"
                      :label="$t('byTime')"
                      value="BY_TIME"
                    ></v-radio>
                    <v-radio
                      id="byYear"
                      :label="$t('byYear')"
                      value="BY_YEAR"
                    ></v-radio>
                    <v-radio
                      id="unWanted"
                      :label="$t('unWanted')"
                      value="UNWANTED"
                    ></v-radio>
                    <v-radio
                      id="company"
                      :label="$t('company')"
                      value="COMPANY"
                    ></v-radio>
                    </v-radio-group>
                </v-col>
              </v-row>
              <v-row justify="center" v-if="receiptTypeCode == 'BY_TIME'||receiptTypeCode == 'BY_YEAR'||receiptTypeCode == 'COMPANY'">
               <v-col cols="6">
                 <div>
                   {{ $t('donorName') }}
                 </div>
                  <v-text-field
                      id="donorName"
                      v-model="form.donorName"
                      :rules="donorNameRules"
                      outlined
                      :placeholder="$t('pleaseInputDonorName')"
                    >
                  </v-text-field>
                </v-col>
               </v-row>
                <v-row justify="center" v-if="receiptTypeCode == 'COMPANY'">
               <v-col cols="6">
                  <v-text-field
                      id="donorSn"
                      v-model="form.donorSn"
                      outlined
                      required
                      :rules="invoiceCompanyUbnRules"
                      :placeholder="$t('pleaseInputInvoiceCompanyUbn')"
                    >
                  </v-text-field>
                </v-col>
               </v-row>
            </div>
             <!--  發票 -->
            <v-row justify="center" v-if="form.store.isInvoiceable">
              <span
                class="
                  text-subtitle text-center text-h4
                  primary--text
                  text--lighten-1
                  title
                "
                >{{ $t('invoice') }}</span
              >
            </v-row>
            <div class="mt-12" v-if="form.store.isInvoiceable">
              <v-row justify="center">
                <v-col cols="6">
                <span>{{ $t('invoiceType') }}</span>
                <v-radio-group
                    id="invoiceType"
                    v-model="form.invoiceType"
                    row
                  >
                    <v-radio
                      :label="$t('personal')"
                      value="PERSONAL"
                    ></v-radio>
                    <v-radio
                      :label="$t('companyUbn')"
                      value="COMPANY"
                    ></v-radio>
                    </v-radio-group>
                </v-col>
              </v-row>
              <v-row justify="center" v-if="form.invoiceType == 'COMPANY'">
               <v-col cols="6">
                  <v-text-field
                      id="invoiceCompanyUbn"
                      v-model="form.invoiceCompanyUbn"
                      outlined
                      required
                      :rules="invoiceCompanyUbnRules"
                      :placeholder="$t('pleaseInputInvoiceCompanyUbn')"
                    >
                  </v-text-field>
                </v-col>
            </v-row>
            </div>

            <!-- 實收金額 -->
            <v-row justify="center">
               <v-col cols="10" md="6">
                 <div class="text-h5">
                   {{ $t('actualAmount') }}
                 </div>
                  <v-text-field
                      id="actualAmount"
                      v-model="actualAmount"
                      outlined
                  >
                  </v-text-field>
                  <span class="text-h5">{{ $t('change') }} {{ change }}</span>
                </v-col>
              </v-row>
            <!-- 結帳方式以商店可付款方式顯示 -->
            <div class="text-center" id="checkoutMethod">
              <v-row justify="center">
                <v-col cols="10" md="6">
                  <v-btn v-for="(paymentTool, index) in paymentTools"
                  :key="paymentTool.code"
                  :id="'paymentTool-' + paymentTool.code"
                  class="payment-button text-h6 ma-2 white--text"
                    x-large
                    depressed
                    :ripple="false"
                    :loading="isLoading"
                    :disabled="isLoading"
                    :color="getPaymentToolColor(index)"
                    @click="checkout(paymentTool)"
                  >{{ paymentTool.name }}
                  </v-btn>

                </v-col>
              </v-row>
            </div>
          </div>
      </v-container>
      </v-form>
    </v-main>
    <v-snackbar
      v-model="formTip"
      multi-line
      top
      :color="formTipColor">
      {{ formTipText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          :ripple="false"
          v-bind="attrs"
          @click="formTip = false">
          <icon-close class="cheerfulgive-icon" />
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import IconReply from '@/assets/icons/reply.vue'
import VueNumberInput from '@chenfengyuan/vue-number-input'
import ImagesLogo2 from '@/assets/images/logo2.vue'
import IconClipboardList from '@/assets/icons/clipboard-list.vue'
import helper from '../helper'
import Api from '../apis'
import _ from 'lodash'
import IconClose from '@/assets/icons/close.vue'
import IconChevronDown from '@/assets/icons/chevron-down.vue'
export default {
  name: 'PosCheckOut',
  components: {
    ImagesLogo2,
    IconClipboardList,
    VueNumberInput,
    IconClose,
    IconChevronDown,
    IconReply
  },
  data () {
    return {
      form: {
        amount: 0,
        currency: 'TWD',
        payerLastName: null,
        payerFirstName: null,
        payerCellphoneCountryCode: 'TW',
        payerCellphone: null,
        payerEmail: null,
        payerId: null,
        store: {
          isInvoiceable: false,
          isReceiptDuctable: false,
          isReceiptDisductable: false
        },
        storeId: null,
        paymentToolCode: null,
        receiptInvoiceType: 'NO',
        receiptTypeCode: 'BY_TIME',
        donorType: 'Personal',
        donorName: null,
        invoiceType: 'PERSONAL',
        invoiceCarrierType: 'payer',
        donorSn: null,
        invoiceCompanyUbn: null,
        invoiceCarrierNumber: null,
        items: [
          {
            productId: null,
            quantity: null,
            price: 0
          }
        ]
      },
      receiptTypeCode: 'BY_TIME',
      payerCellphoneRules: [
        v => !!v || this.$t('pleaseInputCellphoneNumber')
      ],
      payerLastNameRules: [
        v => !!v || this.$t('pleaseInputLastName')
      ],
      payerFirstNameRules: [
        v => !!v || this.$t('pleaseInputFirstName')
      ],
      invoiceCompanyUbnRules: [
        v => !!v || this.$t('pleaseInputInvoiceCompanyUbn'),
        v => (v === null || helper.string.validateUbn(v)) || this.$t('ubnFormatError')
      ],
      donorNameRules: [
        v => !!v || this.$t('pleaseInputDonorName')
      ],
      // 電子信箱規則
      payerEmailRules: [
        v => (!!v || !this.isPayerEmailRequired) || this.$t('pleaseInputEmail'),
        v => helper.string.validateEmail(v) || this.$t('emailFormatError')
      ],
      actualAmount: null,
      stores: [],
      products: [],
      cacheProducts: [],
      paymentTools: [],
      formTipColor: 'success',
      formTip: false, // 是否彈出錯誤訊息
      formTipText: '', // 錯誤訊息內容
      isLoading: false, // 是否登入中
      company: {},
      payer: null
    }
  },
  computed: {
    totalStr () {
      return helper.number.format(
        this.products.filter(it => it.quantity > 0).map(it => it.price * it.quantity).reduce((x, y) => x + y, 0)
      )
    },
    total () {
      return this.products.filter(it => it.quantity > 0).map(it => it.price * it.quantity).reduce((x, y) => x + y, 0)
    },
    change () {
      if (this.actualAmount > 0 && this.actualAmount - this.total >= 0) {
        return helper.number.format(this.actualAmount - this.total)
      } else {
        return ''
      }
    },
    isPayerEmailRequired () {
      if (this.form.store) {
        // eslint-disable-next-line eqeqeq
        return this.form.store.isInvoiceable == true || this.form.receiptTypeCode == 'BY_YEAR'
      } else {
        return false
      }
    }
  },
  watch: {
    'form.invoiceType': function (value) {
      // eslint-disable-next-line eqeqeq
      if (value == 'PERSONAL') {
        this.form.invoiceCarrierType = 'payer'
        this.form.invoiceCompanyUbn = null
      } else {
        this.form.invoiceCarrierType = null
      }
    }
  },
  created () {
    // 載入商店
    this.loadStroes()
    // 載入公司圖示
    this.loadCompany()
  },
  methods: {
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    receiptTypeCodeChange (value) {
      console.log(value)
      switch (value) {
        case 'BY_TIME':
          this.form.receiptTypeCode = 'BY_TIME'
          this.form.donorType = 'Personal'
          if (this.payer) {
            this.form.donorName = this.payer.fullName
          }
          break
        case 'BY_YEAR':
          this.form.receiptTypeCode = 'BY_YEAR'
          this.form.donorType = 'Personal'
          if (this.payer) {
            this.form.donorName = this.payer.fullName
          }
          break
        case 'UNWANTED':
          this.form.receiptTypeCode = 'UNWANTED'
          this.form.donorType = 'Personal'
          if (this.payer) {
            this.form.donorName = ''
          }
          break
        case 'COMPANY':
          this.form.receiptTypeCode = 'BY_TIME'
          this.form.donorType = 'Corporate'
          if (this.payer) {
            this.form.donorName = ''
          }
          break
      }
      this.resetValidation()
    },
    resetFileds () {
      this.form.amount = 0
      this.form.payerLastName = null
      this.form.payerFirstName = null
      this.form.payerCellphone = null
      this.form.payerEmail = null
      this.form.payerId = null
      this.form.paymentToolCode = null
      this.form.receiptInvoiceType = 'NO'
      this.form.receiptTypeCode = 'BY_TIME'
      this.form.donorName = null
      this.form.invoiceType = 'PERSONAL'
      this.form.invoiceCarrierType = 'payer'
      this.form.invoiceCompanyUbn = null
      this.form.items = []
      this.actualAmount = null
      this.products = this.cacheProducts
    },
    getReceiptInvoiceTypeByStore (store) {
      if (store.isReceiptDuctable) {
        return 'DEDUCTIBLE'
      } else if (store.isReceiptDisductable) {
        return 'NONDEDUCTIBLE'
      } else if (store.isInvoiceable) {
        return 'INVOICE'
      } else {
        return 'NO'
      }
    },
    getPaymentToolColor (index) {
      const colors = ['greyBlue', 'orange', 'grassGreen']
      return colors[index % 3]
    },
    checkout (paymentTool) {
      this.isLoading = true
      if (!this.$refs.form.validate()) {
        this.formTipColor = 'error'
        this.formTipText = this.$t('pleaseCheckAllColumns')
        this.formTip = true
        this.isLoading = false
        return false
      }
      this.form.items = this.products.filter(it => it.quantity > 0).map(it => {
        return { productId: it.id, price: it.price, quantity: it.quantity }
      })
      // 產品項目需有值
      if (this.form.items.length === 0) {
        this.formTipColor = 'error'
        this.formTipText = this.$t('pleaseSelectItem')
        this.formTip = true
        this.isLoading = false
        return false
      }
      this.form.paymentToolCode = paymentTool.code
      // eslint-disable-next-line eqeqeq
      if (this.form.store.isReceiptDuctable == false && this.form.store.isReceiptDisductable == false) {
        this.form.receiptTypeCode = 'UNWANTED'
      }
      this.form.amount = this.total
      this.form.receiptInvoiceType = this.getReceiptInvoiceTypeByStore(this.form.store)

      // 若無收據抬頭自動填上姓名
      if (!this.form.donorName) {
        this.form.donorName = this.form.payerLastName + this.form.payerFirstName
      }

      Api.order.checkout(this.form).then(res => {
        // 如果要列印收據就轉到列印畫面
        if (this.form.store.isReceiptDuctable || this.form.store.isReceiptDisductable) {
          // 如果是單筆或公司
          console.log('this.form.receiptTypeCode', this.form.receiptTypeCode)
          if (this.form.receiptTypeCode === 'BY_TIME' || this.form.receiptTypeCode === 'COMPANY') {
            this.$router.push(`/receipt-print?orderId=${res.data.orderId}`)
            return
          }
        }
        this.formTipColor = res.data.success ? 'success' : 'error'
        this.formTipText = res.data.message
        this.formTip = true
        if (res.data.success) {
          this.resetFileds()
          this.resetValidation()
          this.$vuetify.goTo(0)
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    format (value) {
      return helper.number.format(value)
    },
    // 下拉選單, 所選取的商店有變化的時候
    storeChange () {
      this.form.storeId = this.form.store.id
      this.loadProductByStoreId(this.form.storeId)
      this.loadPaymentToolsByStoreId(this.form.storeId)
      this.resetValidation()
    },
    // 填入手機資料, 停止填入後0.5秒開始代入以下姓,名,電子信箱資訊
    cellphoneNumberChange: _.debounce(function () {
      this.loadPayerByCellPhone(this.form.payerCellphone)
    }, 500),
    // 取得商店的單據類型(免開, 發票, 可扣抵收據, 不可扣抵收據)
    getStoreDescription (store) {
      if (store.isReceiptDuctable) {
        return `(${this.$t('receiptInvoiceTypeDeductible')})`
      } else if (store.isReceiptDisductable) {
        return `(${this.$t('receiptInvoiceTypeNonDeductible')})`
      } else if (store.isInvoiceable) {
        return `(${this.$t('receiptInvoiceTypeInvoice')})`
      } else {
        return `(${this.$t('receiptInvoiceTypeNo')})`
      }
    },
    // 篩選商店資料, 只選取實體商店資料
    loadStroes () {
      Api.store.list().then(res => {
        // console.log('res', res)
        // eslint-disable-next-line eqeqeq
        this.stores = res.data.filter(item => item.channelType == 'OFFLINE')
      }).catch(() => {
        this.back()
      })
    },
    loadPaymentToolsByStoreId (storeId) {
      Api.paymentTool.findAllByStoreId(storeId).then(res => {
        this.paymentTools = res.data
      })
    },
    // (1)填入手機資料, 開始代入以下姓,名,電子信箱資訊, (2)開立方式收據抬頭直接帶入基本資料聯絡人姓名
    loadPayerByCellPhone (cellphone) {
      Api.payer.findAllByCellphone(cellphone).then(res => {
        if (res.data.length > 0) {
          this.payer = res.data[0]
          this.form.payerEmail = res.data[0].email
          this.form.payerLastName = res.data[0].lastName
          this.form.payerFirstName = res.data[0].firstName
          this.form.payerId = res.data[0].id
          if (this.receiptTypeCode !== 'COMPANY') {
            this.form.donorName = res.data[0].fullName
          }
        } else {
          this.form.payerId = null
        }
      })
    },
    // 以商店id載入商店商品
    loadProductByStoreId (storeId) {
      Api.product.findAllByStoreId(storeId).then(res => {
        this.products = res.data.map(item => {
          return { ...item, quantity: 0 }
        })
        this.cacheProducts = res.data.map(item => {
          return { ...item, quantity: 0 }
        })
      })
    },
    // 載入公司, 取得公司logo圖片
    loadCompany () {
      Api.company.getInfo().then(res => {
        this.company = res.data
      }).catch(() => {
        this.back()
      })
    },
    //  "清除"按鈕功能
    clear (product) {
      product.quantity = 0
    },

    // 登出, 回到登入頁
    back () {
      // localStorage.clear()
      this.$router.push('/menu')
    },
    // 接到今日收款列表頁面
    toRecord () {
      this.$router.push({
        name: 'Record',
        params: {
          storeId: this.form.storeId
        }
      })
      // if (this.storeId) {
      //   this.$router.push('/record?storeId=' + this.storeId)
      // } else {
      //   this.$router.push('/record')
      // }
    },
    // 產品為數量型與固定單價, 反則為不是數量型, 非固定單價與自訂金額大於０
    productClick (product) {
      if (!product.isStock && product.isFixedPrice) {
        product.quantity = 1
      } else if (!product.isStock && !product.isFixedPrice && product.price > 0) {
        product.quantity = 1
      }
    },
    // 當產品價格大於0, 數量=1, 反之數量則為0
    productPriceChange (product) {
      if (product.price > 0) {
        product.quantity = 1
      } else {
        product.quantity = 0
      }
    },
    receiptPrint (orderId) {
      // 列印收據
      this.$router.push(`/receipt-print?orderId=${orderId}`)
    }
  }
}
</script>

<style>
/*標題底線,顏色*/
.title {
  border-bottom-width: 2px !important;
  border-bottom-style: solid !important;
  border-bottom-color: var(--v-primary-lighten-1) !important
}

/*icon方向翻轉*/
.rotated {
  transform: rotate(180deg)
}

/*分隔線顏色與寬度設定*/
.theme--light.v-divider {
  border-width: 2px !important;
  border-color: #FEAA3C !important;
}

/*產品項目欄位,選擇後所顯示的顏色*/
.product-selected {
  background-color: #FEAA3C !important;
}

/*浮動按鈕, 箭頭位置*/
.arrow-position{
  position: absolute;
  transform: translateY(75%)
}

/* 清除按鈕 */
#cheerfulgive-checkOut .btn-clear {
  border: 1px solid var(--v-blue-base) !important;
  height: 40px;
}

#cheerfulgive-checkOut .input-amount .v-input__slot {
  min-height: 40px;
  background-color: var(--v-white-base) !important;
}

</style>
